<template>
  <select v-bind="{ id, name }" @change.prevent.stop="changeEmit($event.target.value)">
    <option value="">{{ placeholder  ||  $t('commonText.select') }}</option>
    <option v-for="(option, index) in optionsList" :key="index" :value="option.value" :selected="option.value === value">{{ option.text }}</option>
  </select>
</template>

 <script>
  export default {
    name: 'form-select',
    props: {
      options: [Object, Array],
      id: String,
      name: String,
      value: [String, Array],
      placeholder: String
    },
    computed: {
      optionsList () {
        let optionsList = this.options || {}

        if (this.options[0].constructor !== Object) {
          optionsList = this.options.map(current => {
            return {
              value: current,
              text: current
            }
          })
        }

        return optionsList
      }
    },
    methods: {
      changeEmit (changedValue) {
        this.$emit('input', changedValue)
        this.$emit('change', changedValue)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';
  @import '../form-field-default.scss';

  select {
    @include form-field-default;
    width: auto;
    min-width: 80px;
    -webkit-appearance: none;
    -moz-appearance: none;
    color: $color-brown-grey;
    min-height: 30px;
    background: url('/assets/images/icon-arrow-down.svg') #fff right 10px bottom 50% no-repeat;
    background-size: 10px auto;
  }

  .field-holder {
    &.split-column {
      select {
        width: 100%;
      }
    }
  }
</style>
